import { useTranslation } from 'react-i18next';
import { RevxMoney } from '../RevxMoney/index';
import './index.less';
import { useDemoFeatureFlags } from '../../hooks';

export type RevxShippingFormTotalProps = {
  printing: number;
  tax?: number | null;
  freight: number;
  orderTotal: number;
  orderConfirm: boolean;
  hideFreightCost: boolean;
};

export const RevxShippingFormTotal = ({
  printing,
  tax,
  freight,
  orderTotal,
  orderConfirm,
  hideFreightCost,
}: Partial<RevxShippingFormTotalProps>) => {
  const { t } = useTranslation();

  const { transformValue, phoenixEnhancements } = useDemoFeatureFlags();

  // const { showTaxFlag } = useShowTaxFlag();

  // const showTax = useMemo(() => {
  //   return showTaxFlag;
  // }, [showTaxFlag]);

  return (
    <div className="shipping-form-total">
      {!phoenixEnhancements && (
        <>
          <p>
            <label>{t('workspace.confirmation.printing')}:</label>
            <span>
              <RevxMoney value={printing || 0} />
            </span>
          </p>
          {!hideFreightCost && (
            <p>
              <label>{t('workspace.confirmation.freight')}:</label>
              <span data-testid="text-shipping-freight">
                <RevxMoney value={freight || 0} />
              </span>
            </p>
          )}
          <p>
            <label>
              {orderConfirm
                ? t('workspace.confirmation.tax')
                : t('workspace.confirmation.estTax')}
              :
            </label>
            <span>
              <RevxMoney value={tax || 0} />
            </span>
          </p>
        </>
      )}
      <p>
        <label>{t('workspace.confirmation.orderTotal')}:</label>
        <span data-testid="text-shipping-order-total">
          {transformValue(
            <span>
              <RevxMoney value={orderTotal || 0} />
            </span>
          )}
        </span>
      </p>
    </div>
  );
};
